import Model from '@/models/Model'

export const SUBSCRIPTION_BASIC = 'BASIC'
export const SUBSCRIPTION_PLUS = 'PLUS'

export const SUBSCRIPTIONS = {
  [SUBSCRIPTION_BASIC]: 'Bilder Basic',
  [SUBSCRIPTION_PLUS]: 'Bilder Plus'
}

export class Subscription extends Model {
  static get subscriptionOptions () {
    return [
      { name: SUBSCRIPTIONS[SUBSCRIPTION_BASIC], value: SUBSCRIPTION_BASIC },
      { name: SUBSCRIPTIONS[SUBSCRIPTION_PLUS], value: SUBSCRIPTION_PLUS }
    ]
  }

  get name () {
    return getSubscriptionName(this.id)
  }

  get schema () {
    return [
      'id',
      'price'
    ]
  }
}

export default Subscription

export function getSubscriptionName (type) {
  return SUBSCRIPTIONS[type]
}
